import { useIntl } from "@components/Intl"
import { Track, useSlider } from "@components/Slider"
import {
  FilterAction,
  FilterState,
  ProductGroup,
} from "@screens/search/reducer"
import React, { Dispatch, FC, useRef } from "react"
import { FilterButton } from "./FilterButton"
import { SliderNav } from "./SliderNav"
import * as S from "./styles"

type Facets = {
  [key: string]: number
}

type ProductGroupFiltersProps = {
  nbHits: number
  facets?: Facets
  activeGroup: FilterState["productGroup"]
  dispatch: Dispatch<FilterAction>
}

const productGroupFilters = [
  "all",
  "base",
  "bracelet",
  "ring",
  "earring",
  "frame",
  "necklace",
  "stone",
]

export const ProductGroupFilters: FC<ProductGroupFiltersProps> = ({
  facets,
  nbHits,
  activeGroup,
  dispatch,
}) => {
  const trackRef = useRef<HTMLDivElement>(null)
  const { messages } = useIntl()
  const { index, canMoveLeft, canMoveRight, goToIndex } = useSlider({
    trackRef,
  })
  if (!facets) {
    return null
  }
  return (
    <S.Parent>
      <Track ref={trackRef}>
        {productGroupFilters.map((group) => {
          let status = "idle"
          if (group === "all" && nbHits === 0) {
            status = "disabled"
          }
          if (group !== "all" && facets[group] === 0) {
            status = "disabled"
          }
          if (group === activeGroup) {
            status = "active"
          }
          if (group === "all" && activeGroup === null) {
            status = "active"
          }
          if (!facets[group]) {
            return null
          }
          return (
            <FilterButton
              key={group}
              handleClick={() =>
                dispatch({
                  type: "set-product_group-filter",
                  productGroup:
                    group === "all" ? null : (group as ProductGroup),
                })
              }
              amount={group === "all" ? nbHits : facets[group]}
              title={messages.search[group]}
              status={status as any}
            />
          )
        })}
      </Track>
      {canMoveLeft && <SliderNav variant="prev" handleClick={() => prev()} />}
      {canMoveRight && <SliderNav variant="next" handleClick={() => next()} />}
    </S.Parent>
  )

  function prev() {
    index - 1 >= 0 && goToIndex(index - 1)
  }

  function next() {
    index + 1 < Object.keys(productGroupFilters).length && goToIndex(index + 1)
  }
}
